import React from 'react'

import Styles from './CampaignDetailsModal.module.scss'

type Props = {
  label: string
  value: string
}

const CampaignDetailsDottedRow = ({ label, value }: Props) => (
  <div className={Styles.dottedRow}>
    <span className={Styles.dottedRowLabel}>{label}</span>
    <span className={Styles.dottedRowLine} aria-hidden />
    <span className={Styles.dottedRowValue}>{value}</span>
  </div>
)

export default CampaignDetailsDottedRow
